import { render, staticRenderFns } from "./BrandLogoTextboxEcolea.vue?vue&type=template&id=1c96ba8e&"
import script from "./BrandLogoTextboxEcolea.vue?vue&type=script&lang=js&"
export * from "./BrandLogoTextboxEcolea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports